import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  OTPValidator,
  passwordValidator,
} from "../../validators/auth.validators.js";
import { resetPassword } from "../../services/auth.service.js";
import AppError from "../../utils/AppError.js";
import getMessage from "../../utils/getMessage.js";
import "../../styles/auth/auth.css";
import "../../styles/auth/verifyOtp.css";
import OtpInput from "../../components/otp/OtpInput.jsx";
import ResendOtpButton from "../../components/otp/ResendOtpButton.jsx";
import ErrorText from "../../components/auth/ErrorText.jsx";
import PasswordInput from "../../components/auth/PasswordInput.jsx";
import AuthSubmitButton from "../../components/auth/AuthSubmitButton.jsx";

const ResetPasswordVerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const [verifying, setVerifying] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState(null);
  const { email } = location.state || {};

  useEffect(() => {
    if (!email) {
      navigate("/reset-password", { replace: true });
    }
  }, [email, navigate]);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setVerifying(true);
    const otpValue = otp.join("");
    try {
      passwordValidator(password);
      OTPValidator(otpValue);
      await resetPassword({ email, password, otp: otpValue });
      navigate("/login", { replace: true });
    } catch (error) {
      if (error instanceof AppError) {
        setError(error.message);
      } else {
        setError(getMessage("common", "error"));
      }
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="outer">
      <h1 className="auth-heading">Verify OTP</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <ErrorText error={error} />
        <PasswordInput
          password={password}
          setPassword={setPassword}
          resending={resending}
          verifying={verifying}
        />
        <OtpInput
          otp={otp}
          setOtp={setOtp}
          inputsRef={inputsRef}
          verifying={verifying}
          resending={resending}
        />
        <ResendOtpButton
          email={email}
          resending={resending}
          verifying={verifying}
          setError={setError}
          setResending={setResending}
          setOtp={setOtp}
          inputsRef={inputsRef}
        />
        <AuthSubmitButton
          resending={resending}
          verifying={verifying}
          text="VERIFY"
          disabledText="Verifying..."
        />
      </form>
    </div>
  );
};

export default ResetPasswordVerifyOtp;
